import { render, staticRenderFns } from "./CreditsTab.vue?vue&type=template&id=102d7fa8&scoped=true&"
import script from "./CreditsTab.vue?vue&type=script&lang=js&"
export * from "./CreditsTab.vue?vue&type=script&lang=js&"
import style0 from "./CreditsTab.vue?vue&type=style&index=0&id=102d7fa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102d7fa8",
  null
  
)

export default component.exports